export default __webpack_public_path__ + "static/media/notification.30315cfb.svg";